import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import $api, { API } from "../index";

export const getSitemap = createAsyncThunk<string, void>(
  "getSitemap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await $api.get(`${API.getSitemap}`, {});
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message);
      }
      return rejectWithValue(e.toString());
    }
  }
);
